import { Button } from '../../../Utility/Button';
import useChatModels from '../../../../Hooks/useChatModels';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { Model } from '../../../../Types';
import { PencilSimpleIcon, TrashIcon, CopyIcon } from '@phosphor-icons/react';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { modelService } from '../../../../Services/modelService';
import { RootState, useAppSelector } from '../../../../store';
import { UserSettings } from '../../../../Types';
import PaginatedView from '../../../Utility/PaginatedView';

function ChatModels() {
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const { ModelsActions, handleCopyModel, handleNavigate, i18n, settings, windowWidth, getBreakpoint } = useChatModels();
    const GRID_COLS = 'grid-cols-[1fr_auto]'; 

    return (
        <>
            <PaginatedView
                listType={PaginationListType.Models}
                itemsFunction={modelService.getModelsByPage}
                itemsPerPage={15}
                renderItem={(model: Model, index: number) => (
                    <AdminViewContent
                        key={model.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={model.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: model.title,
                                    image: model.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'primaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            handleNavigate(model.identifier),
                                        icon: <PencilSimpleIcon />,
                                    },
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'secondaryRound'
                                                : 'disabledRound',
                                        onClick: () => handleCopyModel(model),
                                        icon: <CopyIcon />,
                                    },
                                    {
                                        variant:
                                            model.hasPrompts || (settings.demo && !userSettings.isSuperAdmin)
                                                ? 'disabledRound'
                                                : 'secondaryRound',
                                        onClick: () =>
                                            !model.hasPrompts && !settings.demo
                                                ? ModelsActions.handleOpenConfirmDialog(model.identifier)
                                                : null,
                                        icon: <TrashIcon />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            >
                {({ list, filter }) => (
                    <>
                        {filter}
                        <div className="mb-4 md:hidden">
                            {(!settings.demo || userSettings.isSuperAdmin) && (
                                <Button className="w-full mb-2" onClick={() => handleNavigate('new')}>
                                    {i18n.translate({ id: 'button', sourceName: 'Models' })}
                                </Button>
                            )}
                        </div>
                        <div className="hidden md:block">
                            <div className={`grid ${GRID_COLS} gap-4 w-full px-4`}>
                                <div className="text-lg flex items-center">
                                    <strong>{i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' })}</strong>
                                </div>
                                {(!settings.demo || userSettings.isSuperAdmin) && (
                                    <div className="flex justify-end gap-2">
                                        <Button
                                            variant="primary"
                                            className="h-[51px]"
                                            onClick={() => handleNavigate('new')}
                                        >
                                            {i18n.translate({ id: 'button', sourceName: 'Models' })}
                                        </Button>
                                    </div>
                                )}
                            </div>
                            <hr className="border-layout-borderColor mt-5" />
                        </div>
                        {list}
                    </>
                )}
            </PaginatedView>
        </>
    );
}

export default ChatModels;
